import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button';
import LoadingButton from '@atlaskit/button/loading-button';
import { fg } from '@atlaskit/platform-feature-flags';
import { G300, N0 } from '@atlaskit/theme/colors';
import { CustomCheckCircle } from './icons';
import { messages } from './messages';
import { Content, Heading, Rectangle, ResultContainer, SubmitAnotherButtonWrapper, SuccessWrapper } from './styled';
export const IssueCreatedEmbedded = ({
  issueKey,
  onCreateClick
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Rectangle, null), /*#__PURE__*/React.createElement(SuccessWrapper, null, /*#__PURE__*/React.createElement(ResultContainer, null, /*#__PURE__*/React.createElement(CustomCheckCircle, {
  circle: `var(--ds-icon-success, ${G300})`,
  tick: `var(--ds-surface, ${N0})`,
  size: "84"
}), /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement(FormattedMessage, fg('itsm-issue-renaming') ? messages.successfullyCreatedTitleEmbedIssueTermRefresh : messages.successfullyCreatedTitleEmbed)), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, fg('itsm-issue-renaming') ? messages.successfullyCreatedDescriptionWithLinkEmbedIssueTermRefresh : messages.successfullyCreatedDescriptionWithLinkEmbed, {
  values: {
    a: () => /*#__PURE__*/React.createElement(Button, {
      appearance: "link",
      spacing: "none",
      href: `/browse/${issueKey}`,
      target: "_blank"
    }, issueKey)
  }
}))), /*#__PURE__*/React.createElement(SubmitAnotherButtonWrapper, null, /*#__PURE__*/React.createElement(LoadingButton, {
  appearance: "primary",
  onClick: onCreateClick,
  testId: "proforma-jira-issue-forms.ui.issue-forms.smart-links.create-another-button"
}, /*#__PURE__*/React.createElement(FormattedMessage, fg('itsm-issue-renaming') ? messages.successfullyCreatedButtonEmbedIssueTermRefresh : messages.successfullyCreatedButtonEmbed))))));